import { render, staticRenderFns } from "./ContentEditText.vue?vue&type=template&id=1be809ed&"
import script from "./ContentEditText.vue?vue&type=script&lang=js&"
export * from "./ContentEditText.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDivider,VTextarea})
